var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameBrowserArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 289 492",
    style: {
      enableBackground: "new 0 0 289 492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.2,226.8L62.3,7.9C57.2,2.8,50.4,0,43.2,0s-14,2.8-19,7.9L8.1,24C-2.4,34.5-2.4,51.6,8.1,62l183.9,183.9 L7.9,430C2.8,435,0,441.8,0,449c0,7.2,2.8,14,7.9,19L24,484.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L281.2,265 c5.1-5.1,7.9-11.9,7.8-19.1C289.1,238.7,286.3,231.9,281.2,226.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameBrowserArrow);
export default __webpack_public_path__ + "static/media/game_browser_arrow.79b494cd7d13faa9962affac2679a4c1.svg";
export { ForwardRef as ReactComponent };